import { faFacebookF, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();

function Footer({ style }) {
    return (
        <footer className={`footer ${style ? 'dark-mode' : ""}`}>
            
            <Container>
                <Row className="justify-content-between">
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/images/4.png" alt="Mr. Hassan Maher" />
                            </div>
                            <p className="footer-description">
                                منصة تعليمية متخصصة في الفيزياء تحت إشراف مستر حسن ماهر
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={8} md={6} className="mb-4">
                        <div className="footer-section">
                            <h5>تواصل معنا</h5>
                            <div className="social-links">
                                <Link to="https://www.facebook.com/share/19B9sBPKEU/?mibextid=wwXIfr" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </Link>
                                <Link to="https://youtube.com/@mr.hassanmaher?si=_C7_sbLHTEJHvYrt" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </Link>
                                <Link to="https://www.instagram.com/mr.hassanmaher?igsh=MTRrMW1pZ253dDgzNQ==" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </Link>
                                {/* <Link to="https://www.tiktok.com/@engahmedessaam?_t=ZS-8yjtVCQ84if&_r=1" target="_blank" className="social-link">
                                    <FontAwesomeIcon icon={faTiktok} />
                                </Link> */}
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <div className="footer-bottom">
                    <div className="copyright">
                        <span>Developed by</span> 
                        <Link to="https://www.facebook.com/said.sayed.3386" target="_blank">Said</Link> , 
                        <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank">Nassef</Link> 
                        <span>All Copy Rights Reserved © {currentYear}</span>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;